// @ts-nocheck
import { canUseDOM } from "exenv";
import warning from "tiny-warning";

let globalElement: string | HTMLElement | null = null;

export function assertNodeList(nodeList: { length: number }, selector: string) {
    if (!nodeList || !nodeList.length) {
        throw new Error(`mobius: No elements were found for selector ${selector}.`);
    }
}

export function setElement(element: string) {
    let useElement: string | HTMLElement = element;
    if (typeof useElement === "string" && canUseDOM) {
        const el = document.querySelectorAll(useElement);
        assertNodeList(el, useElement);
        useElement = "length" in el ? (el[0] as HTMLElement) : el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
}

export function validateElement(appElement: HTMLElement) {
    if (!appElement && !globalElement) {
        warning(
            false,
            [
                "mobius: Overlay app element is not defined.",
                "Please use `Overlay.setAppElement(el)` or set `appElement={el}`.",
                "This is needed so screen readers don't see main content",
                "when modal is opened.",
            ].join(" "),
        );

        return false;
    }

    return true;
}
// Store Custom Code - >
export const getGapWidth = () => {
    const documentWidth = document.documentElement.clientWidth;
    const windowWidth = window.innerWidth;

    return Math.max(0, windowWidth - documentWidth);
};
export function hide(appElement?: HTMLElement) {
    // header is fixed so our workaround to stop layout shift won't work on it.
    const header = document.querySelector(".header-wrapper");
    if (header) {
        const headerStyle = window.getComputedStyle(header);
        if (headerStyle.position === "fixed") {
            header.setAttribute("style", `padding-right: ${getGapWidth()}px;`);
        }
    }

    document.querySelector("body")?.setAttribute(
        "style",
        `overflow: hidden !important;
    position: relative !important;
    padding-left: 0px;
    padding-top: 0px;
    padding-right: 0px;
    margin-left: 0;
    margin-top: 0;
    margin-right: ${getGapWidth()}px;`,
    );
}
// Store Custom Code - <--
export function show(appElement?: HTMLElement) {
    document.querySelector("body")?.removeAttribute("style");
    document.querySelector(".header-wrapper")?.removeAttribute("style");
}
